import { t } from "@/i18n";
import type { CreateSubMenuActions } from "@/interface/WidgetMenu";

export const AI_ANSWER_PADDING = 20;

export const AI_ANSWER_GAP = 12;

export const AI_ICON_HEGHT = 24;

export const LOADING_ANIMATION_PADDING_H = 100;

export const LOADING_ANIMATION_PADDING_V = 70;

export const LOADING_ANIMATION_WIDTH = 150;

export const LOADING_ANIMATION_HEIGHT = 120;

export const getAiTitle = (action: CreateSubMenuActions) => {
    switch (action) {
        case "short_summary":
            return t("aiActions.shortSummary");
        case "retro_summary":
            return t("aiActions.retro");
        default:
            return "";
    }
};

export const AI_TEXT_HARD_WIDTH = 520;
